import React, { useEffect, useState, useRef } from 'react';
import { View, Text, StyleSheet, Animated, TouchableOpacity, Linking, Image, ScrollView } from 'react-native';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles
import Sidebar from './sidebar';  // ✅ Import the new Sidebar
import Footer from './footer'; // ✅ Import Footer
import Header from './header'; // ✅ Import Footer


const Career = ({ navigation }) => {

  const [activeLink, setActiveLink] = useState('Career');

  const [showSidebar, setShowSidebar] = useState(false);

  const handleLinkPress = (screen) => {
    setShowSidebar(false); // Close sidebar on navigation
    navigation.navigate(screen);
  };

   const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };


  return (
    <View style={styles.pageContainer}>

    {/* Fixed Header */}
    <View style={styles.fixedHeader}>
       <Header onToggleSidebar={toggleSidebar} />
    </View>

      {showSidebar && (
        <Sidebar
          activeLink={activeLink}
          handleLinkPress={handleLinkPress}
          onClose={() => setShowSidebar(false)}
        />
      )}


    {/* Scrollable Content */}
    <ScrollView contentContainerStyle={styles.scrollContainer}>

      {/* Main Content */}
      <View style={styles.mainContent}>
        <Text style={styles.heading}>Careers</Text>

      <View style={{ height: 20 }} /> 
      
       <View style={styles.imageWrapper}>
        <Image
          source={require('./assets/career.png')}
          style={styles.storyImage}
          resizeMode="cover"
        />
      </View>

       {/* Plain Paragraphs */}
      <View style={styles.paragraphContainer}>
     

        <Text style={styles.paragraph}>
          At IntegrationX, we’re building the future of intelligent automation and AI-powered integrations. We’re always on the lookout for passionate, curious, and driven individuals who share our vision of empowering businesses through technology.
        </Text>

      </View>
      

      

       {/* Plain Paragraphs */}
      <View style={styles.paragraphContainer}>
        <Text style={styles.paragraph}>
          We don't have any open roles at the moment — but we're growing fast! If you're excited about what we're building and believe you can contribute to our mission, we’d still love to hear from you. Send us your resume and a quick note about why you'd be a great fit.
        
        </Text>
         <Text
            style={[styles.paragraph, { textAlign: 'center' }]}
            onPress={() => Linking.openURL('mailto:careers@integrationx.ai')}
          >
            Email us at careers@integrationx.ai
          </Text>
      </View>

     
      
       <View style={{ height: 20 }} />

        <Text style={styles.heading}>Why Us</Text>

      <View style={styles.imageWrapper}>
        <Image
          source={require('./assets/whyus.jpg')}
          style={styles.storyImage}
          resizeMode="cover"
        />
      </View>

       {/* Plain Paragraphs */}
       <View style={[styles.paragraphContainer, { alignItems: 'center' }]}>
          <Text style={styles.paragraph}>🧠  Work with cutting-edge AI and automation</Text>
          <Text style={styles.paragraph}>🌐  Solve real business challenges across industries</Text>
          <Text style={styles.paragraph}>🛠️  Be part of a fast-moving and collaborative team</Text>
          <Text style={styles.paragraph}>🌱  Grow with a company that invests in your development</Text>
           <Text style={styles.paragraph}>⏰ Flexible work hours to suit your lifestyle</Text>
        </View>


        {/* Footer */}
        <Footer navigation={navigation} />

      </View>
      </ScrollView>
    </View>
  );
};

export default Career;
